import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { useStore } from "../lib/store";
import { jstToday } from "../lib/jst";

const shapes = {
  sidebar: "aspect-[3/4]",
  catalog_mid: "aspect-[16/6]",
  footer: "aspect-[16/5]",
};

/** Slot iklan/poster yang diisi pemilik dari Pengaturan. */
export const PosterSlot = ({ slot, channel }) => {
  const { lang } = useI18n();
  const { settings } = useStore();
  const [idx, setIdx] = useState(0);

  const today = jstToday();
  const list = (settings?.posters || []).filter(
    (p) =>
      p.active !== false &&
      p.image_url &&
      p.slot === slot &&
      (p.channel === "both" || p.channel === channel) &&
      (!p.start_date || p.start_date <= today) &&
      (!p.end_date || p.end_date >= today)
  );

  useEffect(() => {
    if (list.length < 2) return undefined;
    const id = setInterval(() => setIdx((i) => (i + 1) % list.length), 6000);
    return () => clearInterval(id);
  }, [list.length]);

  if (list.length === 0) return null;
  const p = list[Math.min(idx, list.length - 1)];
  const title = (lang === "ja" && p.title_ja) || p.title || "";
  const isInternal = p.link?.startsWith("/");
  const track = () => {
    if (p.id) api.post(`/posters/${p.id}/click`).catch(() => {});
  };

  const media = (
    <div
      className={`relative overflow-hidden rounded-2xl border border-gray-200 bg-white ${shapes[slot] || shapes.sidebar}`}
    >
      <img
        src={p.image_url}
        alt={title}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 hover:scale-[1.03]"
      />
      {title && slot === "sidebar" && (
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <p className="text-white text-sm font-medium leading-snug">{title}</p>
        </div>
      )}
      <span className="absolute top-2 right-2 rounded-full bg-black/50 px-2 py-0.5 text-[10px] uppercase tracking-wide text-white">
        Ad
      </span>
      {list.length > 1 && (
        <div className="absolute bottom-2 right-2 flex gap-1">
          {list.map((x, i) => (
            <span
              key={`${x.id || x.image_url}-${i}`}
              className={`h-1.5 w-1.5 rounded-full ${i === idx ? "bg-white" : "bg-white/40"}`}
            />
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div data-testid={`poster-slot-${slot}`}>
      {!p.link && media}
      {p.link && isInternal && (
        <Link to={p.link} onClick={track} data-testid={`poster-link-${slot}`}>
          {media}
        </Link>
      )}
      {p.link && !isInternal && (
        <a
          href={p.link}
          target="_blank"
          rel="noopener noreferrer"
          onClick={track}
          data-testid={`poster-link-${slot}`}
        >
          {media}
        </a>
      )}
    </div>
  );
};
